import React from 'react';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
// import { getAdditionalPage } from '../../../../services';
import AdditionalPage from '@/containers/AdditionalPage';
import Layout from '@/components/Layout';
// import { getSSRStoreData } from '../../../../utils/ssrPageData';
// import { useSetSSRStore, useSSRSelector } from '../../../../redux';
import { fetchAdditionalPageSeoDetails } from 'src/utils/fetchAdditionalPageSeoDetails';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';
import { getSSRStoreData } from 'src/utils/ssrPageData';
import { getAdditionalPage } from 'src/services';
import { useSetSSRStore, useSSRSelector } from 'src/redux';
import { handleCategoryCollectionRedirect } from 'src/utils/productUtils';
import { set404Response } from 'src/utils/404Redirect';
import Error404 from 'src/containers/404Page';

const AdditionalPageContainer = (props) => {
  const advCustomSeo = props.advCustomSeoDetails;
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);
  if (props?.notFound) {
    return <Error404 />
  }
  return (
    <Layout
      store={storeInfo}
      title={
        advCustomSeo?.title?.value ||
        `${props?._addPage?.page_name} - ${storeInfo?.store_info?.name}`
      }
      Icon={storeInfo?.store_info?.logo_image}
      metaDescription={
        advCustomSeo?.description ||
        'Now order online from my whatsapp store & pay using 150+ UPI Apps'
      }
      OGTitle={advCustomSeo?.og_title?.value || null}
      OGDescription={advCustomSeo?.og_description || null}
      OGImage={storeInfo?.store_info?.logo_image}
      isCustomDomain={props.isCustomDomain}
      canonicalTagUrl={props?._addPage?.redirect_url}
      {...props}
    >
      <AdditionalPage {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};
  const { slug, template_id, preview } = ctx.query;
  let propData = {
    catalogCategories: [],
    _addPage: null,
    collections: [],
    advCustomSeoDetails: {},
  };

  const propType = await getSSRStoreData(ctx, {
    additionalDataToFetch: [
      'collections',
      'categories',
      'advancedSeo',
      'additionalPagesList',
    ],
  });

  if (propType?.ssrStore?.storeReducer?.store?.store_id) {
    const _addpageResponse = await getAdditionalPage(
      slug,
      propType?.ssrStore?.storeReducer?.store?.store_id,
      Boolean(Number(preview)),
      template_id,
      1,
    );


    if (_addpageResponse.data && _addpageResponse.data.status) {
      propData._addPage = JSON.parse(JSON.stringify(_addpageResponse.data.page)) || null;

      // fetch advance seo data after fetching additional page data
      const storeInfo = propType.ssrStore.storeReducer.store;
      propType.advCustomSeoDetails = await fetchAdditionalPageSeoDetails({
        type: 'additional_page',
        typeId: propData?._addPage?.page_id,
        storeInfo,
      });
      if( _addpageResponse?.data?.page?.is_redirected) {
        const redirectionLink = _addpageResponse?.data?.page?.redirect_url ;
        return handleCategoryCollectionRedirect({ ctx, redirectionLink });
      }
      
    } else {
      return set404Response(ctx, propType);
    }
  }

  propData = { ...propData, ...(propType || {}) };
  const extraProps = getRequiredCtxProps(ctx, propType);

  return { props: { ...propData, ...extraProps } };
}

export default AdditionalPageContainer;
